<nb-layout windowMode *ngIf="!bootLoading">
    <nb-layout-header *ngIf="showTopBar" class="on-top" fixed>
        <app-header class="h-100" [showSidebar]="showSidebar"></app-header>
    </nb-layout-header>


    <nb-layout-column class="main-container">
        <dg-menu [items]="menu" [header] = headerMenu *ngIf="(isMobileSize || showSidebar) && authService.isAuthenticated()"></dg-menu>
        <div class="main-content"
            [class]="{'distance-collapsed-right':showSidebar && toggleState === 'collapsed' && authService.isAuthenticated(),'distance-expanded-right':showSidebar &&toggleState === 'expanded' && authService.isAuthenticated(), 'no-pad': (!showTopBar && !showFooter) || noPaddingPage}">
            <router-outlet></router-outlet>
        </div>
        <app-footer *ngIf="showFooter"></app-footer>
    </nb-layout-column>
    <!-- <nb-layout-footer fixed *ngIf="currentLocation !== 'auth/signup'">
    </nb-layout-footer> -->
    <!-- <nb-layout-footer *ngIf="showFooter">
        
    </nb-layout-footer> -->
    <ng-container #serviceRef></ng-container>
</nb-layout>